import type { GeneralIconProps } from "@next-bricks/icons/general-icon";

export const ADD_ICON: GeneralIconProps = {
  lib: "fa",
  icon: "plus",
};

export const MODEL_ICON: GeneralIconProps = {
  lib: "lucide",
  icon: "box",
};
